module.exports = __webpack_public_path__ + "img/satellite.16234a7b.png";